import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from 'OpsCenter/shared/shared.module';
import {AgentsComponent} from "OpsCenter/agents/agents.component";
import {AgentsService} from "OpsCenter/agents/agents.service";


@NgModule({
  imports: [HttpClientModule, CommonModule, SharedModule, FormsModule],
  declarations: [AgentsComponent],
  providers: [AgentsService],
  entryComponents: [AgentsComponent],
})
export class AgentsModule {
}



// WEBPACK FOOTER //
// ./src/app/agents/agents.module.ts